export default "__VITE_ASSET__DVhwCUsD__"